module.exports = __webpack_public_path__ + "static/img/giftbox.f0c9844e.png";